import { Box } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  usePerformanceProcessPendingReviewersDataTable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'

interface Props {
  pendingReviewersIds: number[]
}

const PendingReviewersDataTable = ({ pendingReviewersIds }: Props) => {
  const source = usePerformanceProcessPendingReviewersDataTable(
    [
      {
        identifier: 'target',
        title: i18n.t('performance_process.reviews.peer_management.peers_datatable.employee'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ employee_access_fullName }}',
        colSpan: 2,
        render: ({ employeeName }) => {
          return employeeName && <InlineEmployee employee={employeeName} />
        },
      },
      {
        identifier: 'manager',
        title: i18n.t('performance_process.reviews.peer_management.peers_datatable.manager'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ employee_manager_access_fullName }}',
        colSpan: 2,
        render: ({ employeeName }) => {
          return employeeName?.managerName ? (
            <InlineEmployee employee={employeeName.managerName} hideAvatar />
          ) : (
            '-'
          )
        },
      },
    ],
    {
      variables: { ids: pendingReviewersIds },
      defaultSort: 'firstName',
    }
  )

  return (
    <DataTable.Provider
      source={source}
      pagination={{
        kind: 'cursor',
        itemsPerPage: 50,
      }}
    >
      <Box gap="s16" overflowY="hidden">
        <DataTable.HeadBar
          exportFileName={i18n.t('performance_process.overview.participation.export_filename')}
        />
        <DataTable.Table />
      </Box>
    </DataTable.Provider>
  )
}

export default PendingReviewersDataTable
